<!-- =========================================================================================
  File Name: User.vue
  Description: User information and editing
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <vs-alert color="danger" title="Datos de usuario no encontrados" :active.sync="id_not_found">
      <span>Datos de usuario con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'users'}" class="text-inherit underline"> todos los usuarios</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="data_local" class="mb-2" v-show="loaded">

      <div slot="no-body" class="tabs-container px-6 pt-6">
        <div class="vx-row">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1">
            <div class="w-full">
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Identificación del usuario" v-model="data_local.user" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Nombre del usuario" v-model="data_local.name" :enabled="editing"/>
              </div>
              <div class="w-full">
                <ejs-textbox class="e-input" type="text" floatLabelType="Auto" placeholder="Dirección de correo electrónico" v-model="data_local.email" :enabled="editing"/>
              </div>
              <div class="w-full mb-2">
                <ejs-dropdownlist
                  floatLabelType="Auto"
                  placeholder="Empresa"
                  ref="branch"
                  highlight=true
                  v-model="data_local.branchId"
                  :dataSource="branches"
                  :fields="{text: 'name', value: 'id'}"
                  :enabled="editing"
                  :query='branchQuery'
                  allowFiltering=true
                  :filtering='branchFiltering'
                />
              </div>
              <div class="w-full mb-2">
                <ejs-dropdownlist floatLabelType="Auto" placeholder="Estado" highlight=true :dataSource="status" :fields="{text: 'value', value: 'code'}" v-model="data_local.statusId" :enabled="editing"></ejs-dropdownlist>
              </div>
              <div class="w-full mb-2">
                <ejs-multiselect ref="roles" floatLabelType="Auto" placeholder="Roles asignados" :dataSource="roles" mode="Box" :fields="{text: 'role', value: 'id'}" v-model="data_local.rolList" :enabled="editing"></ejs-multiselect>
              </div>
            </div>
          </div>

        </div>

        <div class="vx-row">
          <div class="vx-col w-full mb-4">
            <div class="flex flex-wrap items-center justify-end">
              <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" v-show="!editing" @click="editing = true">Editar</vs-button>
              <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" class="mr-4" v-show="!editing" @click="confirmDeleteRecord">Eliminar</vs-button>
              <vs-button type="border" color="success" icon-pack="feather" icon="icon-key" @click="isChangePasswordActive = true" v-show="!editing">Cambiar clave</vs-button>
              <vs-button class="ml-auto" @click="save" v-show="editing" :disabled="!validateForm">Guardar cambios</vs-button>
              <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data" v-show="editing">Cancelar</vs-button>
            </div>
          </div>
        </div>
      </div>
    </vx-card>

    <vs-prompt
      :active.sync="isChangePasswordActiveLocal"
      :is-valid="validPassword"
      @accept="savePassword"
      @cancel="cancel"
      accept-text="Aceptar"
      cancel-text="Cancelar"
      :title="`Cambio de clave para usuario ${data_local.user}`"
    >
      <div>
        Especifique la clave para el usuario <b>{{ data_local.name }}</b>
        <vs-input
          :danger="validatePassword"
          danger-text="Debe especificar una clave de acceso"
          class="mt-4 mb-2 w-full"
          placeholder="Clave"
          type="password"
          v-model="password"
          val-icon-danger="clear"
          val-icon-success="done"
        />
        <vs-input
          :danger="validateConfirmPassword"
          class="mt-4 mb-2 w-full"
          danger-text="Confirmación no coincide con clave"
          placeholder="Confirme clave"
          type="password"
          v-model="confirmPassword"
          val-icon-danger="clear"
          val-icon-success="done"
        />
      </div>
    </vs-prompt>

  </div>
</template>

<script>
  var deltaPOS_config = require('@/deltaPOS.config.js');
  import Vue from "vue";
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";
  import {MultiSelectPlugin} from "@syncfusion/ej2-vue-dropdowns";
  // import {MultiSelect, TaggingEventArgs} from '@syncfusion/ej2-dropdowns';
  import {Query} from "@syncfusion/ej2-data";

  Vue.use(TextBoxPlugin);
  Vue.use(DropDownListPlugin);
  Vue.use(MultiSelectPlugin);

  export default {
    data() {
      return {
        loaded: false,
        editing: false,
        data: null,
        branches: [],
        status: [],
        roles: [],
        branchQuery: new Query().select(['name', 'id']).take(10),
        data_local: {
          id: 0,
          user: '',
          name: '',
          email: ''
        },
        id_not_found: false,
        password: '',
        confirmPassword: '',
        errorPassword: '',
        errorConfirmPassword: '',
        isChangePasswordActive: false
      }
    },
    watch: {
      isChangePasswordActive() {
        if (this.isChangePasswordActive) {
          this.clearPassword();
        }
      }
    },
    computed: {
      isChangePasswordActiveLocal: {
        get() {
          return this.isChangePasswordActive
        },
        set(val) {
          if (val) {
            this.clearPassword();
          } else {
            this.$emit('closeChangePassword');
          }
        }
      },
      validPassword() {
        return (this.password.length > 0 && this.password == this.confirmPassword)
      },
      validatePassword() {
        return (this.password.length == 0)
      },
      validateConfirmPassword() {
        return (this.confirmPassword != this.password)
      },
      errorMessage() {
        var ret = '';
        if (this.password.length == 0) {
          ret = 'Debe especificar una clave de acceso'
        }
        if (this.password != this.confirmPassword) {
          ret = 'Clave y confirmación no coinciden'
        }
        return ret
      }
    },
    methods: {
      reset_data() {
        if (this.$route.params.id > 0) {
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.editing = false;
        } else {
          this.$router.push({name: 'users'});
        }
      },
      branchFiltering: function (e) {
        var searchData = JSON.parse(JSON.stringify(this.branches));
        if (e.text == '') {
          e.updateData(searchData);
        } else {
          // var query = new Query().select(['name', 'id']);
          var query = new Query().select(['name', 'id']);
          query = (e.text !== '') ? query.where('name', 'contains', e.text, true, true) : query;
          e.updateData(searchData, query);
        }
      },
      validateForm() {
        var message = '';
        if (this.data_local.user.trim() == '') {
          message = 'Debe especificar usuario';
        } else if (this.data_local.name.trim() == '') {
          message = 'Debe especificar un nombre';
        }
        if (this.data_local.statusId.trim() == '') {
          this.data_local.statusId = 'ACT';
        }
        if (message != '') {
          this.$vs.notify({
            title: 'Error en información de usuario',
            text: message,
            color: 'danger'
          });
        }
        return (message == '');
      },
      getData(id) {
        if (id) {
          if (id == 0) {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            var self = this;
            var data = {
              id: parseInt(this.$route.params.id),
              context: this.$store.state.AppActiveUser
            };
            this.$http.post(deltaPOS_config.default.apiURL + '/users/data', data).then(response => {
              if (response.data.success) {
                self.data = response.data.data;
                self.data_local = JSON.parse(JSON.stringify(response.data.data));
              } else {
                if (id > 0) {
                  this.id_not_found = true;
                }
              }
              self.$vs.loading.close();
              self.loaded = true;
            })
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando datos de usuario',
            type: 'point'
          });
          var self = this;
          this.data_local.id = parseInt(this.$route.params.id);
          this.data_local.context = this.$store.state.AppActiveUser;
          this.$http.post(deltaPOS_config.default.apiURL + '/users/save', this.data_local).then(response => {
            if (response.data.success) {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Datos de usuario fueron actualizados correctamente',
                color: 'primary'
              });
              self.$router.push({name: 'user', params: {id: response.data.data.id}});
              self.editing = false;
            } else {
              self.$vs.notify({
                title: 'Error al actualizar',
                text: response.data.message,
                color: 'danger'
              });
            }
            this.$vs.loading.close();
          });
        }
      },
      confirmDeleteRecord() {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a eliminar usuario <b>${this.data.user}</b> - ${this.data.name}`,
          accept: this.deleteRecord,
          acceptText: "Delete"
        })
      },
      deleteRecord() {
        /* Below two lines are just for demo purpose */
        this.$router.push({name: 'users'});
        this.showDeleteSuccess()

        /* UnComment below lines for enabling true flow if deleting user */
        // this.$store.dispatch("userManagement/removeRecord", this.user_data.id)
        //   .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
        //   .catch(err => { console.error(err)       })
      },
      showDeleteSuccess() {
        this.$vs.notify({
          color: 'success',
          title: 'Usuario eliminado',
          text: 'Datos de usuario fueron eliminados'
        })
      },

      clearPassword() {
        this.password = '';
        this.confirmPassword = '';
        this.errorPassword = '';
        this.errorConfirmPassword = '';
      },
      savePassword() {
        this.$vs.loading({
          text: 'Guardando clave de usuario',
          type: 'point'
        });
        var self = this;
        this.data_local.id = parseInt(this.$route.params.id);
        this.data_local.password = this.password;
        this.data_local.createdBy = parseInt(localStorage.getItem('EventsDPUserId'));
        this.data_local.context = this.$store.state.AppActiveUser;
        this.$http.post(deltaPOS_config.default.apiURL + '/users/changePassword', this.data_local).then(response => {
          if (response.data.success) {
            self.$vs.notify({
              title: 'Información actualizada',
              text: 'Clave actualizada',
              color: 'primary'
            });
          } else {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: response.data.message,
              color: 'danger'
            });
          }
          self.$vs.loading.close();
          self.cancel();
        })
      },
      cancel() {
        this.isChangePasswordActive = false;
      }
    },

    mounted() {
      var self = this;
      this.$vs.loading({
        text: 'Cargando datos de usuario',
        type: 'point'
      });
      this.$http
        .post(deltaPOS_config.default.apiURL + '/branches/list', this.$store.state.AppActiveUser)
        .then(response => {
          if (response.data.success) {
            self.branches = response.data.data;
          }
          self.$http
            .post(deltaPOS_config.default.apiURL + '/lists/get_list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token, list: 'ESTADOUSUARIO'})
            .then(response => {
              if (response.data.success) {
                self.status = response.data.data;
              }
              self.$http
                .post(deltaPOS_config.default.apiURL + '/roles/list', {userId: this.$store.state.AppActiveUser.userId, token: this.$store.state.AppActiveUser.token})
                .then(response => {
                  if (response.data.success) {
                    self.roles = response.data.data;
                  }
                  self.getData(this.$route.params.id);
                });
            });
        });
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';*/
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
</style>
